import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";

const json = {
  1: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U1-P19-E1",
    audio: "",
    video: "",
    protractor: true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page19/Key/E1answerKey.jpg",
    component: T6,
    inputSize: 175,
    stylesTextInput: {
      background: "transparent",
      border: "none",
      borderBottom: "1px solid gray",
      fontSize: "24px",
      textAlign: "center",
    },
    titleQuestion: [
      {
        num: "1",
        title: `Sử dụng thước đo góc để đo các góc sau.`,

        color: "rgb(1,172,118)",
        star: 1,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
				<div>
				<img id="tam-giac-img" src="/img/test/tam-giac.png" alt="" width={400} />
				<img id="tam-giac-img" src="/img/test/90 do.jpg" alt="" width={400} />
				</div>
				
        `,
        answer: [],
      },
    ],
  },
  2: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U1-P19-E2",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page19/Key/E2answerKey.jpg",
    component: T6,
    inputSize: 175,
    isHiddenCheck: true,
    stylesTextInput: {
      background: "transparent",
      border: "none",
      borderBottom: "1px solid gray",
      fontSize: "24px",
      textAlign: "center",
    },
    titleQuestion: [
      {
        num: "2",
        title: ` Complete the rules with <i>extreme</i> or <i>normal</i>.`,
        color: "rgb(1,172,118)",
        star: 1,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
				
		
				<div style='position: relative;'>
				  <div><img src='img/FriendsPlus/Page19/E2/1.jpg' width='100%' /></div>
				  <div style='position: absolute; top: 96px; left: 29px;'>#</div>
				  <div style='position: absolute; top: 134px; left: 459px;'>#</div>
				  

		
				  
		
				  
				  
				</div>
			  </div>
        `,
        answer: ["extreme", "normal"],
      },
    ],
  },
  3: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U1-P19-E3",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "",
    component: Circle_Write,
    inputSize: 200,
    textAlign: "center",
    titleQuestion: [
      {
        num: "3",
        title: `Choose the correct words. There may be 
        more than one answer.`,
        color: "rgb(1,172,118)",
        // prefix: { icons: ['far fa-comment'], text: '' },
        star: 2,
      },
    ],
    question: {
      Write: {
        inputStyle: {
          width: 120,
          textAlign: "center",
        },
        answers: [``],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          padding: "-40px",
          // fontWeight: 600,
          color: "",
          // fontSize: 27,
          borderRadius: "50%",
          padding: "5px",
          // marginInline: '-1px',
        },
        selectWordStyle: { border: "3px solid rgb(0, 173, 238)" },
        limitSelect: 1,
        listWordsStyle: {},
        listWords: [
          "very / really",
          "very / absolutely",
          "miserable / sad ",
          "really / absolutely",
          "good / amazing",
          "really / absolutely",
          "very / amazing",
          "very / really",
        ],
        answers: [""],
        initialValue: [],
      },
      Layout: `
      <div>The music at the festival is <b><span style="border:3px solid black;border-radius:50%;padding:5px">very </span> / absolutely</b>  loud.<div>
			<div><strong style="margin-right:15px">1</strong>The beaches in this area are <strong><input id="0" type="Circle"></strong> pretty.</div>
			<div><strong style="margin-right:15px">2</strong>The food is <strong><input id="1" type="Circle"></strong> disgusting</div>
			<div><strong style="margin-right:15px">3</strong>I felt very <strong><input id="2" type="Circle"></strong> when we left.</div>
			<div><strong style="margin-right:15px">4</strong>The tickets are <strong><input id="3" type="Circle"></strong> cheap.</div>
			<div><strong style="margin-right:15px">5</strong>These sights are absolutely <strong><input id="4" type="Circle"></strong>.</div>
					
			<div><strong style="margin-right:15px">6</strong>Our journey was <strong><input id="5" type="Circle"></strong> awful.</div>
					
			<div><strong style="margin-right:15px">7</strong> Ireland is <strong><input id="6" type="Circle"></strong> beautiful.</div>
				
			<div><strong style="margin-right:15px">8</strong>The water-slide was <strong><input id="7" type="Circle"></strong> terrifying. </div>
					
        `,
    },
  },
  4: {
    unit: "Unit 2",
    id: "FP8-wB-demo-2023-U2-P19-E4",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page19/Key/E4answerKey.jpg",
    component: T6v2,
    inputSize: 160,
    // maxLength: 1,
    stylesTextInput: {
      fontSize: "17.6px",
      textAlign: "center",
      background: "transparent",
    },
    titleQuestion: [
      {
        num: "4",
        title: `
        Read the advert and complete the 
        competition entry with the words.
				`,
        color: "rgb(1,172,118)",
        star: 2,
      },
    ],
    isHiddenCheck: true,
    questions: [
      {
        title: `
        <div style="display:flex">
        <div style="margin-top:210px;margin-right:30px"><img src='img/FriendsPlus/Page19/E4/1.jpg' width='100%' /></div>
        <div>
        <div style='margin-top: 20px; display: flex; gap: 30px;max-width:490px;margin-left:50px;margin-bottom:20px'>
				<div style='flex: 1; border-radius: 20px; padding: 20px 30px; border: 3px solid rgb(1,172,118)'>
				  <div><span style="margin-right:20px;margin-left:70px">don't forget</span><span>is absolutely</span></div>
				  <div><span style="margin-right:20px;margin-left:40px">is quite a / an</span><span>looking forward to</span></div>
				  <div><span style="margin-right:20px;text-decoration:line-through;margin-left:60px">one of the most</span><span>surprisingly</span></div>
				  
				  
				</div>
				
			  </div>
		
				<div style='position: relative;'>
				  <div><img src='img/FriendsPlus/Page19/E4/2.jpg' width='100%' /></div>
				  <div style='position: absolute; top: 177px; left: 155px;'>#</div>
				  <div style='position: absolute; top: 260px; left: 435px;'>#</div>
				  <div style='position: absolute; top: 358px; left: 28px;'>#</div>
				  <div style='position: absolute; top: 406px; left: 160px;'>#</div>
				  <div style='position: absolute; top: 472px; left: 296px;'>#</div>

	 
				</div>
			  </div>
        </div>
        </div>
				`,
        answer: [
          "is absolutely",
          "surprisingly",
          "is quite an",
          "don't forget",
          "looking forward to",
        ],
      },
    ],
  },
  5: {
    unit: "Unit 2",
    id: "FP8-wB-demo-2023-U2-P19-E5",
    audio: "",
    video: "",
    component: T6v2,
    inputSize: 800,
    stylesTextInput: {
      fontSize: "24px",
    },
    textareaStyle: { width: "900px" },
    titleQuestion: [
      {
        num: "5",
        title: `
        Write your own competition entry. 
        Use the text in exercise 3 to help you. Include 
        intensifiers, adjectives and the phrases on this 
        page.
				`,
        color: "rgb(1,172,118)",
        star: 3,
      },
    ],
    questionImage: [],
    hideBtnFooter: true,
    isHiddenCheck: true,
    questions: [
      {
        title: `
					<textarea id="0" rows="7"></textarea>
				`,
        answer: [],
      },
    ],
  },
};

export default json;
